import { render, staticRenderFns } from "./IcToplist.vue?vue&type=template&id=332c573a&scoped=true"
import script from "./IcToplist.vue?vue&type=script&lang=js"
export * from "./IcToplist.vue?vue&type=script&lang=js"
import style0 from "./IcToplist.vue?vue&type=style&index=0&id=332c573a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c573a",
  null
  
)

export default component.exports